import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import AutoBindComponent from "../common/AutoBindComponent";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";

import { Dropdown } from "semantic-ui-react";

class AutoComplete extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
		this.MINSEARCHLENGTH = 1;
		this.MAXITEMCOUNT = 10;

		this.state = {
			search: ''
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return this.props.value !== nextProps.value || this.state.search !== nextState.search || this.props.validationMessage !== nextProps.validationMessage || this.props.disabled !== nextProps.disabled;
	}

	handleOnSearch(e, event) {
		const options = [];
		const value = event.searchQuery;
		if (value.length > this.MINSEARCHLENGTH) {
			const regexpToSearch = new RegExp("^" + value, "i");
			const searchresults = this.props.items.filter(item => item.label.match(regexpToSearch));

			for (let i = 0; i < searchresults.length; i++) {
				options.push({ text: searchresults[i].label, value: searchresults[i].value });
			}
		}
		const state = { options: options, search: value };

		this.setState(state);
	}

	handleOnChange(e, data) {
		if (this.props.onChange) {
			const customEvent = { target: data };
			this.props.onChange(customEvent, data);
		}
	}

	handleOnClear(e) {
		e.stopPropagation();
		this.setState({ options: [], search: '' });
		const data = { name: this.props.name, value: "" };
		this.props.onChange({ target: data }, data);
	}

	getLabelItemByValue(value, noId) {
		if (!noId) {
			let label = "";
			const item = this.props.items.find(item => item.value == value);
			if (item != null) {
				label = item.label;
			}
			return label;
		}
		return value;
	}

	render() {
		const noId = this.props.hasNoId;
		const hasValidationMessage = !!this.props.validationMessage;
		const validationMessageType = this.props.validationMessageType;
		const tooltiptype = this.props.tooltipType || types.TOOLTIP_INFO;
		const defaultItem = this.props.defaultItem ? this.props.defaultItem : "Kies een optie";
		const value = this.props.value ? this.props.value : "";
		const sizeClassName = this.props.size ? "o-col-" + this.props.size : "o-col-12";
		const label = this.props.label + (this.props.optional ? " (Optioneel)" : "");
		const info = this.props.tooltip ? <Tooltip isInput text={this.props.tooltip} tooltipType={tooltiptype} /> : null;
		const validation = this.props.validationMessage ? <ValidationMessage message={this.props.validationMessage} type={validationMessageType} /> : null;
		const icon = 'search';
		const id = generateGuid();
		const noResultsMessage = this.props.noResultsMessage ? this.props.noResultsMessage : types.AUTOCOMPLETE_NO_RESULTS_LETTERS;
		let text = "";


		const inputClassName = classnames({
			"c-input__field": true
		});
		const labelClassName = classnames({
			"c-input__label": true,
			"has-value": true
		});

		const containerClassName = classnames({
			"c-input": true,
			"c-input--dropdown": true,
			"has-value": true,
			"error": hasValidationMessage && validationMessageType !== types.ValidationMessageTypes.WARNING,
			"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
			"disabled": this.props.disabled
		});
		if (value) {
			text = this.getLabelItemByValue(value, noId);
		}

		const options = this.state.options ? this.state.options : [];
		return (
			<div className={sizeClassName}>
				<div className={containerClassName}>
					<Dropdown
						id={id}
						className={inputClassName}
						fluid
						text={text}
						selection
						icon={icon}
						search
						name={this.props.name}
						closeOnChange
						selectOnBlur={false}
						value={this.props.clearable ? value : undefined}
						options={options}
						placeholder={defaultItem}
						onChange={this.handleOnChange}
						disabled={this.props.disabled}
						loading={this.props.loading}
						onSearchChange={this.handleOnSearch}
						noResultsMessage={noResultsMessage}
					/>
					<label className={labelClassName} htmlFor={id}>{label}</label>
					{info}
					{this.props.clearable && value &&
						<i
							className="fa fa-times c-autocomplete-clear"
							onMouseDown={this.handleOnClear}
							title="Wissen"
							style={{ position: "absolute", right: "2.25rem", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#999", zIndex: 11 }}
						/>}
				</div>
				{validation}
			</div>
		);
	}
}

AutoComplete.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	defaultItem: PropTypes.string,
	items: PropTypes.array.isRequired,
	loading: PropTypes.bool,
	hasNoId: PropTypes.bool,
	noResultsMessage: PropTypes.string,
	clearable: PropTypes.bool
};

export default AutoComplete;
